import { FeatureNotificationId, MathseedsReportPath } from 'teacher-ui-client/services/feature-notification'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import type ImpressionService from 'teacher-ui-client/services/impression'
import { SideNavAccordionItem, SideNavAccordionList } from 'teacher-ui-client/components/side-nav/accordion'
import graphUnfilled from '@images/icons/graph-unfilled.svg'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'
import { Lozenge } from 'teacher-ui-client/components/lozenge'
import { t } from 'ember-intl'
import { FeatureNotification } from 'teacher-ui-client/helpers/feature-notification'

export class MathseedsReportsAccordion extends Component<unknown> {
  @service sideNav!: SideNavService

  @service impression!: ImpressionService

  get hasNewMathseedsReports() {
    return Object.values(MathseedsReportPath).some((reportPath) => {
      return !this.impression.wasMade(reportPath)
    })
  }

  get uiScopeModels() {
    return this.sideNav.uiScopeModels ?? []
  }

  <template>
    <SideNavAccordionList
      @iconUrl={{graphUnfilled}}
      @iconAlt="Sidenav bar"
      @label={{t "sideNav.reports.title"}}
      @showNotificationDot={{this.hasNewMathseedsReports}}
    >
      <SideNavAccordionItem
        data-test-maths-link-dashboard
        @route="reporting.ui-scope.maths.dashboard"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="dashboard"}}
      >{{t "sideNav.reports.dashboard"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.summary.table"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="summary"}}
      >{{t "sideNav.reports.summary"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.time-on-task"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="time-on-task"}}
      >{{t "sideNav.reports.timeOnTask"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        data-test-maths-standards-performance
        @route="reporting.ui-scope.maths.standards-performance"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="standards-performance"}}
      >{{t "sideNav.reports.standards"}}
        {{#if
          (FeatureNotification
            FeatureNotificationId.NewReportForPath reportPath=MathseedsReportPath.StandardsPerformance
          )
        }}
          <Lozenge data-test-maths-new-lozenge>{{t "new"}}</Lozenge>
        {{/if}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        data-test-maths-lesson-performance
        @route="reporting.ui-scope.maths.lesson-performance"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="lesson-performance"}}
      >{{t "sideNav.reports.lessonPerformance"}}
        {{#if
          (FeatureNotification FeatureNotificationId.NewReportForPath reportPath=MathseedsReportPath.LessonPerformance)
        }}
          <Lozenge data-test-maths-new-lozenge>{{t "new"}}</Lozenge>
        {{/if}}
      </SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.course-progress.lessons"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="course-progress-lessons"}}
      >{{t "sideNav.reports.courseProgress"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.skills-mastered.cohort.students-results"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="skills-mastered-cohort-students-results"}}
      >{{t "sideNav.reports.skillsMastered"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.assessment-scores"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="assessment-scores"}}
      >{{t "sideNav.reports.mapQuizzes"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        data-test-maths-link-driving
        @route="reporting.ui-scope.maths.driving-tests"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="driving-tests"}}
      >{{t "sideNav.reports.drivingTests"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.awards-earned"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="awards-earned"}}
      >{{t "sideNav.reports.certificatesEarned"}}</SideNavAccordionItem>
      <SideNavAccordionItem
        @route="reporting.ui-scope.maths.fluency-sprints.teacher"
        @currentWhen="reporting.ui-scope.maths.fluency-sprints"
        @models={{this.uiScopeModels}}
        {{posthogEvent "Reporting" product="maths" page="fluency-sprints"}}
      >{{t "sideNav.reports.fluencySprints"}}</SideNavAccordionItem>
    </SideNavAccordionList>
  </template>
}
export default MathseedsReportsAccordion
